import { render, staticRenderFns } from "./Typo3SubscriptionDetails.vue?vue&type=template&id=6ececc96&scoped=true"
import script from "./Typo3SubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./Typo3SubscriptionDetails.vue?vue&type=script&lang=js"
import style0 from "./Typo3SubscriptionDetails.vue?vue&type=style&index=0&id=6ececc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ececc96",
  null
  
)

export default component.exports